export const YTD_PRODUCTION_COLUMNS = [
  {
    name: 'empNo',
    options: {
      display: 'excluded'
    }
  },
  {
    name: 'name',
    label: 'Team',
    options: {
      display: true,
      sort: true
    }
  },

  {
    name: 'total',
    label: 'Total',
    options: {
      display: true,
      sort: true,
      renderer: 'currency',
      setCellProps: () => ({ style: { textAlign: 'right' } }),
      setCellHeaderProps: () => ({
        style: { textAlign: 'right', display: 'flex', justifyContent: 'flex-end' }
      })
    }
  }
];

export const ORDER_BY_OPTIONS = {
  column: 'name',
  direction: 'asc'
};
